<template>
    <div class="components-person-info">
        <div class="person-info-nav">
            <ul>
                <li
                    v-for="(item, index) in navList"
                    :key="index"
                    class="info-nav-item"
                    :class="{ active: active === item.componentName }"
                    @click="changeSwitch(item.componentName)"
                >
                    {{ item.name }}
                </li>
            </ul>
        </div>
        <div class="person-info-pan page-content">
            <component :is="active" :username="username"></component>
        </div>
    </div>
</template>

<script>
import infoPanel from "./info-panel";
import headerImage from "./header-image";
import dakaHistory from "./daka-history";
import loginHistory from "./login-history";
import peixunHistory from "./peixun-history";
import projectHistory from "./project-history";
import renzhiHistory from "./renzhi-history";

import { mapState } from "vuex";
export default {
    components: {
        infoPanel,
        headerImage,
        dakaHistory,
        loginHistory,
        peixunHistory,
        projectHistory,
        renzhiHistory,
    },
    data() {
        return {
            active: "infoPanel",
            navList: [
                {
                    name: "个人资料",
                    componentName: "infoPanel",
                },
                {
                    name: "头像照片",
                    componentName: "headerImage",
                },
                {
                    name: "企业任职经历",
                    componentName: "renzhiHistory",
                    hideByUserFrom: true,
                },
                {
                    name: "登录历史",
                    componentName: "loginHistory",
                },
            ],
        };
    },
    computed: {
        ...mapState({
            username: (state) => state.user.oauth.userCode,
            userFrom: (state) => state.user.oauth.userFrom,
        }),
    },
    methods: {
        /**
         * 切换标签
         * @param str
         */
        changeSwitch(str) {
            this.active = str;
        },
    },
};
</script>

<style lang="scss" scoped>
.components-person-info {
    .person-info-nav {
        background: rgba(245, 247, 250, 1);
        box-shadow: 0px 1px 0px 0px rgba(205, 207, 212, 1);
        padding: 4px $content-both-sides-padding;
    }
    .info-nav-item {
        display: inline-block;
        height: 26px;
        line-height: 26px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(227, 228, 228, 1);
        padding: 0 14px;
        color: #666666;
        margin-right: 8px;
        border-radius: 2px;
        cursor: pointer;
        &.active {
            background: $primary;
            color: white;
            border-color: $primary;
        }
    }
}
</style>
